import { css } from "@emotion/react";

/** Keeps wide tables inside the docs main column without overlapping side nav. */
export const scrollWrapper = css({
  maxWidth: "100%",
  overflowX: "auto",
  margin: "1rem 0",
  WebkitOverflowScrolling: "touch",
});

export const table = css({
  width: "100%",
  borderCollapse: "collapse",
});

export const cellText = css({
  overflowWrap: "break-word",
  verticalAlign: "top",
});
